import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTopInfoBarController } from 'src/hooks/useTopInfoBarController';
import { DismissContainer, InfoBarContainer, topInfoBarTransitionTime } from './InfoBar.styles';
import Button from 'atoms/Button/Button';
import XClose from 'app/icons/Monospaced/X/XClose';
import { cssVar } from 'styles/helper';
import useElementResize from 'src/hooks/useElementResize';
import InactiveNetworkLayout from './Layouts/InactiveNetwork';
import PeopleMagicProfitAnnouncementBar from './Layouts/PeopleMagicProfitAnnouncementBar';

export const TopBarInfoLayoutList = {
  inactiveNetworks: InactiveNetworkLayout,
  peopleMagicProfitAnnouncement: PeopleMagicProfitAnnouncementBar,
};

export type TopBarInfoLayouts = keyof typeof TopBarInfoLayoutList;

const InfoBar = (): JSX.Element => {
  const [removeContent, setRemoveContent] = useState(false);
  const topBarRef = useRef<HTMLDivElement>();

  const {
    isVisible,
    content,
    hide,
    dismissible,
    backgroundColor = 'bg-primary-solid',
    dismissButtonColor = 'fg-white',
    customStyles,
  } = useTopInfoBarController();
  const InfoContent = TopBarInfoLayoutList[content as TopBarInfoLayouts];
  const isHidden = useMemo(() => !isVisible || !InfoContent, [isVisible, InfoContent]);

  const { height } = useElementResize(topBarRef);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (!isVisible && content) {
      timeout = setTimeout(() => setRemoveContent(true), topInfoBarTransitionTime);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [isHidden, content]);

  return (
    <InfoBarContainer
      ref={topBarRef}
      $background={backgroundColor}
      $dismissible={dismissible}
      $customStyles={customStyles}
      id='info_bar'
      className='info-bar'
      style={{
        marginTop: isHidden ? -height : 0,
        display: !!content && !removeContent ? 'flex' : 'none',
      }}
    >
      {InfoContent && <InfoContent />}
      {dismissible && (
        <DismissContainer data-color-mode='dark'>
          <Button
            size='md'
            variant='tertiary'
            onClick={hide}
            icon={
              <XClose
                width={20}
                color={cssVar(dismissButtonColor)}
              />
            }
            iconPosition='right'
          />
        </DismissContainer>
      )}
    </InfoBarContainer>
  );
};

export default InfoBar;
